import PaginationItem from '@mui/material/PaginationItem';
import { styled } from '@mui/material/styles';

export default styled(PaginationItem)(({ theme }) => ({
  color: theme.custom.textActive,
  '&.Mui-selected': {
    fontWeight: 'bold',
    color: '#ffffff',
  },
  '&.MuiPaginationItem-page&.Mui-selected': {
    backgroundColor: `${theme.custom.primary}`,
    color: '#ffffff',
  },
}));
